export default "__VITE_ASSET__DrgzP49A__"